import React, { useState } from "react";
import Textarea from "react-textarea-autosize";

const Field = ({ id, label, placeholder, value, onChange, onBlur }) => {
  return (
    <div className="mb-4">
      <label
        className="block text-gray-700 text-sm font-bold mb-2"
        htmlFor={id}
      >
        {label}
      </label>
      <Textarea
        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        id={id}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
      />
    </div>
  );
};

const WriteTab = ({ episode, setEpisode }) => {
  const [localEpisode, setLocalEpisode] = useState(episode);
  const {
    prompt,
    promptSource,
    sponsor,
    sponsorDescription,
    answer,
  } = localEpisode;

  return (
    <form className="">
      <Field
        id={`${episode.id}prompt`}
        label="Prompt"
        placeholder="What would you do if you knew you couldn't fail?"
        value={prompt}
        onChange={(prompt) => setLocalEpisode({ ...episode, prompt })}
        onBlur={() => {
          console.log({ localEpisode, episode });
          setEpisode(localEpisode);
        }}
      />

      <Field
        id={`${episode.id}promptSource`}
        label="Prompt Source"
        placeholder="Your Thoughts listener James Todd"
        value={promptSource}
        onChange={(promptSource) =>
          setLocalEpisode({ ...episode, promptSource })
        }
        onBlur={() => setEpisode(localEpisode)}
      />

      <Field
        id={`${episode.id}sponsor`}
        label="Sponsor and Tagline"
        placeholder="Air: breath it"
        value={sponsor}
        onChange={(sponsor) => setLocalEpisode({ ...episode, sponsor })}
        onBlur={() => setEpisode(localEpisode)}
      />

      <Field
        id={`${episode.id}sponsorDescription`}
        label="Sponsor and Link"
        placeholder="Air. To learn more, visit https://air.com."
        value={sponsorDescription}
        onChange={(sponsorDescription) =>
          setLocalEpisode({ ...episode, sponsorDescription })
        }
        onBlur={() => setEpisode(localEpisode)}
      />

      <Field
        id={`${episode.id}answer`}
        label="My Answer"
        placeholder="I'd probably launch a podcast."
        value={answer}
        onChange={(answer) => setLocalEpisode({ ...episode, answer })}
        onBlur={() => setEpisode(localEpisode)}
      />
    </form>
  );
};

export default WriteTab;
